import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const Dropdown = ({ children, defaultText = "", textIcon = "" }) => {
  const [isOpen, setOpen] = useState(false);
  const [showClass, setShowClass] = useState("");

  useEffect(() => {
    if (isOpen) {
      setShowClass("show");
    } else {
      setShowClass("");
    }
  }, [isOpen]);

  return (
    <span className="dropdown">
      <a
        className={`nav-icon dropdown-toggle ${showClass}`}
        onClick={() => setOpen(!isOpen)}
      >
        {defaultText ? (
          defaultText
        ) : (
          <span className="nav-title">{textIcon}</span>
        )}
      </a>
      <ul className={`dropdown-menu dropdown-menu-right ${showClass}`}>
        {children}
      </ul>
    </span>
  );
};

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  defaultText: PropTypes.string,
  textIcon: PropTypes.string
};

export default Dropdown;
